// import React, { Suspense, useEffect, useState } from "react";
// import { Navigate, Route, Routes } from "react-router-dom";
// import { CSpinner } from "@coreui/react";

// import routes from "../routes";

// const AppContent = () => {
//   const [isLoading, setLoading] = useState(false);
//   const token = localStorage.getItem("token");

//   useEffect(() => {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     setLoading(false);
//   }, []);

//   return (
//     <>
//       {isLoading ? (
//         <div> Hi</div>
//       ) : (
//         <div>
//           <Routes>
//             {token ? (
//               routes.map((route, idx) => {
//                 return (
//                   route.element && (
//                     <Route
//                       key={idx}
//                       path={route.path}
//                       exact={route.exact}
//                       name={route.name}
//                       element={<route.element />}
//                     />
//                   )
//                 );
//               })
//             ) : (
//               <Route path="*" element={<Navigate to="/" replace />} />
//             )}
//             {/* Default route */}
//             <Route
//               path="/"
//               element={
//                 token != null ? (
//                   <Navigate to="dashboard" replace />
//                 ) : (
//                   <Navigate to="loginWithOTP" replace />
//                 )
//               }
//             />
//           </Routes>
//         </div>
//       )}
//     </>
//   );
// };

// export default React.memo(AppContent);

import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "../routes";

const AppContent = () => {
  const token = localStorage.getItem("token");

  return (
    <Routes>
      {token ? (
        // Only show app routes if logged in
        routes.map((route, idx) =>
          route.element ? (
            <Route
              key={idx}
              path={route.path}
              exact={route.exact}
              name={route.name}
              element={<route.element />}
            />
          ) : null
        )
      ) : (
        // If no token, redirect all routes to /
        <Route path="*" element={<Navigate to="/" replace />} />
      )}

      {/* Default route */}
      <Route
        path="/"
        element={
          token ? (
            <Navigate to="dashboard" replace />
          ) : (
            <Navigate to="loginWithOTP" replace />
          )
        }
      />
    </Routes>
  );
};

export default React.memo(AppContent);
